import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'software-code-code-page.common.empty-state-card.title',
		defaultMessage: '{provider} connected',
		description: 'This title describes the provider that is connected.',
	},
	description: {
		id: 'software-code-code-page.common.empty-state-card.description',
		defaultMessage:
			'Not seeing your repositories? <sac>Use issue keys</sac> to link them or <config>check the app configuration</config>',
		description: 'This text describes how to link development information with Jira Issues',
	},
	dismissButtonLabel: {
		id: 'software-code-code-page.common.empty-state-card.dismiss-button-label',
		defaultMessage: 'Dismiss',
		description: 'This text describes the aria-label for the button to dismiss the card',
	},
});
